<template>
  <svg
    :class="['chevron', direction]"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.64896 3.301L17.3352 11.3075C17.7067 11.6944 17.7067 12.3056 17.3352 12.6925L9.64896 20.699C8.96758 21.4088 7.83243 21.4088 7.15105 20.699C6.50789 20.029 6.50788 18.971 7.15105 18.301L13.2 12L7.15105 5.699C6.50788 5.02904 6.50788 3.97096 7.15105 3.301C7.83243 2.59123 8.96758 2.59123 9.64896 3.301Z"
      fill="currentColor"
    />
  </svg>
</template>
<script>
export default {
  props: {
    /* Accepted values: up, right, down, left */
    direction: {
      type: String,
      required: false,
      default: 'right',
    },
  },
}
</script>

<style lang="scss" scoped>
.chevron {
  transition: transform 200ms ease-out;
}
.up {
  transform: rotate(-90deg);
}
.right {
  transform: rotate(0deg);
}
.down {
  transform: rotate(90deg);
}
.left {
  transform: rotate(180deg);
}
</style>
